import { useSearchParams } from 'react-router-dom';
import { PageHeader } from '../../components/AppShell';
import { Tabs } from '../../components/ui';
import { ProductsTab } from './catalog/ProductsTab';
import { CategoriesTab } from './catalog/CategoriesTab';
import { VendorsTab } from './catalog/VendorsTab';

type TabKey = 'products' | 'categories' | 'vendors';

export function CatalogPage() {
  const [params, setParams] = useSearchParams();
  const raw = params.get('tab');
  const tab: TabKey = raw === 'categories' || raw === 'vendors' ? raw : 'products';

  return (
    <>
      <PageHeader title="Products & vendors"
        description="The approved catalogue the technical team selects from, the brands and categories it is organised under, and the vendors we buy from." />
      <div className="space-y-4 p-4 sm:p-6">
        <Tabs<TabKey>
          tabs={[{ key: 'products', label: 'Products' }, { key: 'categories', label: 'Categories & brands' }, { key: 'vendors', label: 'Vendors' }]}
          active={tab}
          onChange={(k) => setParams(k === 'products' ? {} : { tab: k }, { replace: true })} />
        {tab === 'products' && <ProductsTab />}
        {tab === 'categories' && <CategoriesTab />}
        {tab === 'vendors' && <VendorsTab />}
      </div>
    </>
  );
}
